import React, { useEffect, useState, useRef } from "react";
import "./doctorCases.scss";
import { CaseDetail } from "../../../models/CaseDetail/caseDetail.model";
import { CaseStatusEnum } from "../../../enums/caseStatus.enum";
import AppLoader from "../../../shared/components/AppLoader";
import AppCard from "../../../shared/components/AppCard";
import {
  Badge,
  Button,
  Drawer,
  Menu,
  Modal,
  Popconfirm,
  Popover,
  Table,
  TablePaginationConfig,
  Tooltip,
  Input,
  Row,
  Col,
} from "antd";
import moment from "moment";
import DoctorCaseService from "../../../services/Case/DoctorCase/doctorCase.service";
import CaseOverview from "../../../shared/components/CaseOverview";
import {
  copyCaseDetailsToClipboard,
  stopPropogateEvent,
} from "../../../shared/utils/eventUtils";
import { CaseBodyPart } from "../../../models/CaseBodyPart/caseBodyPart.model";
import {
  DownloadOutlined,
  CloudDownloadOutlined,
  FormOutlined,
  EllipsisOutlined,
  CopyOutlined,
  RedoOutlined,
  HistoryOutlined,
  UserAddOutlined,
  EditOutlined,
  LockOutlined,
  CommentOutlined,
} from "@ant-design/icons";
import ReportForm from "../../../shared/components/ReportForm";
import ReportService from "../../../services/Report/report.service";
import { DownloadFileTypeEnum } from "../../../enums/downloadFileType.enum";
import { hasDoctorAccessToCase } from "../../../shared/utils/accessUtils";
import { UserRoleEnum } from "../../../enums/userRole.enum";
import CaseFilterForm from "../../../shared/components/CaseFilterForm";
import { CaseFilterParams } from "../../../models/CaseFilterParams/caseFilterParams.model";
import {
  getCustomCellStyles,
  formatStatus,
  getInitialFiltersFromURL,
  hexToRgba,
} from "../../../shared/utils/dataFormatConverter";
import { generatePath, useHistory } from "react-router-dom";
import { AppRoutes } from "../../../routes/routeConstants/appRoutes";
import { buildCaseDetailViewerUrl } from "../../../shared/utils/caseViewerOpenUrl";
import { getCosignConfirm } from "../../../shared/utils/cosignConfirm";
import CaseContainer from "../../../store/container/CaseContainer";
import { CaseReducerProps } from "../../../store/reducers/caseReducer";
import ReportLockContainer from "../../../store/container/ReportLockContainer";
import { ReportLockReducerProps } from "../../../store/reducers/reportLockReducer";
import { Switch } from "antd";
import ProfileService from "../../../services/Profile/profile.service";
import { Doctor } from "../../../models/Doctor/doctor.model";
import { useLocation } from "react-router-dom";
import SharedCaseService from "../../../services/Shared/shared.service";
import Notification from "../../../shared/components/Notification";
import { NotificationTypes } from "../../../enums/notificationTypes";
import { PaginationMeta } from "../../../models/PaginationMeta/paginationMeta.model";
import { AdminFeatureEnum } from "../../../enums/AdminFeature.enum";
import ContextMenu from "../../../shared/components/ContextMenu";
import CaseChatDrawer from "../../../shared/components/CaseChatDrawer";
import { Tag } from "../../../models/Tag/tag.model";
import TagLegend from "../../../shared/components/TagLegend";
import ReportHistory from "../../../shared/components/ReportHistory";
import { DoctorFeatureEnum } from "../../../enums/DoctorFeature.enum";
import { TagEnum } from "../../../enums/tag.enum";
import CaseAssignmentForm from "../AdminCases/CaseAssignmentForm";
import CaseForm from "../ScanCenterCases/CaseForm";
import CaseSeriesExpandRow from "../../../shared/components/CaseSeriesExpandRow";
import ListingColumnPreferenceService, {
  ListingColumnPreferencesResponse,
} from "../../../services/ListingColumnPreference/listingColumnPreference.service";
import {
  ACTIONS_COLUMN_MIN_WIDTH,
  DEFAULT_ACTIONS_COLUMN_WIDTH,
  LISTING_CONTEXT,
  ListingColumnKey,
  minWidthForListingColumnKey,
} from "../../../constants/listingColumnKeys";
import { applyListingColumnPreferences } from "../../../utils/listingColumns/applyListingColumnPreferences";
import { mergeListingWidthsFromTable } from "../../../utils/listingColumns/mergeListingWidthsFromTable";
import {
  buildCaseChatUnreadCountsFromCases,
  getDisplayedCaseChatUnread,
} from "../../../shared/utils/caseChatUnread";
import { useHighlightCaseRowFromQuery } from "../../../shared/hooks/useHighlightCaseRowFromQuery";

const getReportedReports = (caseDetail: CaseDetail | undefined) =>
  caseDetail?.reports?.filter((r) => r.status === true) ?? [];

interface DoctorCasesProps extends CaseReducerProps, ReportLockReducerProps {}

function DoctorCases({
  createdCaseId,
  updatedCaseId,
  deletedCaseId,
  setNewCaseCreated,
  setCaseDetailUpdated,
  setCaseDeleted,
  eventId,
  lockEvent,
  lockEventReportId,
  lockEventLockedBy,
  caseChatUnreadCounts,
  mergeCaseChatUnread,
  setCaseChatDrawerCaseId,
}: DoctorCasesProps) {
  const location = useLocation();

  const [me, setMe] = useState<Doctor>();

  const [caseDetails, setCaseDetails] = useState<CaseDetail[]>([]);
  
  const [loading, setLoading] = useState(false);

  const { rowClassName: caseListRowClassName } = useHighlightCaseRowFromQuery(
    caseDetails,
    loading
  );

  const [isSyncing, setSyncing] = useState(false);

  const [downloadLoading, setDownloadLoading] = useState(false);

  const [downloadZipLoading, setDownloadZipLoading] = useState(false);

  const [activeCase, setActiveCase] = useState<CaseDetail>();

  const [showCaseOverview, setShowCaseOverview] = useState(false);

  const [showReportHistory, setShowReportHistory] = useState(false);

  const [showReportForm, setShowReportForm] = useState(false);

  const [isModalVisible, setIsModalVisible] = useState(false);

  const [activePopoverId, setActivePopoverId] = useState<number | null>(null);

  const [phoneNumber, setPhoneNumber] = useState("");

  const assignmentPopoverRef = useRef<any>(null);

  const [showCaseForm, setShowCaseForm] = useState(false);

  const handleToggleCaseForm = () =>
    setShowCaseForm((showCaseForm) => !showCaseForm);

  const [formValues, setFormValues] = useState<CaseFilterParams>(
    Object.assign(new CaseFilterParams(), {
      ...new CaseFilterParams(),
      fromDate: moment().format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
    })
  );

  const [paginationMeta, setPaginationMeta] = useState<PaginationMeta>(
    Object.assign(new PaginationMeta(), {
      currentPage: 1,
      totalCount: 0,
      totalPages: 0,
    })
  );

  const debounceTimerRef = useRef<NodeJS.Timeout | null>(null);

  const resizingColumnRef = useRef(null);

  const startXRef = useRef(0);

  const startWidthRef = useRef(0);

  // report_id → locked_by display_name (real-time socket events)
  const [lockedReports, setLockedReports] = useState<Record<number, { name: string }>>({});

  const [menuVisible, setMenuVisible] = useState(false);

  const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });

  const [caseChat, setCaseChat] = useState<{ id: number; title: string } | null>(
    null
  );

  const [selectedRow, setSelectedRow] = useState<any>(null);

  const menuRef = useRef<HTMLDivElement>(null);

  // const adminFeatures = me?.adminFeatures?.map(
  //   (adminFeature) => adminFeature.feature
  // );

  const handleSubmit = (values: CaseFilterParams) => {
    const formValues = Object.assign(new CaseFilterParams(), values);
    setFormValues(formValues);
    handleFetchCases(formValues);
  };

  const handleOnChange = (updatedValues: CaseFilterParams) => {
    // Update the form values with new inputs
    const newFormValues = Object.assign(new CaseFilterParams(), updatedValues);
    setFormValues(newFormValues);

    // Clear any existing debounce timer
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }

    // Set a new debounce timer
    debounceTimerRef.current = setTimeout(() => {
      // handleFetchCases(newFormValues); // Call the fetch function with the updated form values
    }, 500); // 500ms debounce delay
  };

  // Cleanup on component unmount to clear the debounce timer
  useEffect(() => {
    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, []);

  // Track report lock events for real-time lock icon in listing
  useEffect(() => {
    if (!lockEvent || !lockEventReportId) return;
    const isReportLockEnabled = (me?.adminFeatures ?? []).some(
      (f) => f.feature === AdminFeatureEnum.REPORT_LOCK
    );
    if (!isReportLockEnabled) return;
    if (lockEvent === "acquired" && lockEventLockedBy) {
      setLockedReports((prev) => ({
        ...prev,
        [lockEventReportId]: { name: lockEventLockedBy.display_name },
      }));
    }
    if (lockEvent === "released") {
      setLockedReports((prev) => {
        const next = { ...prev };
        delete next[lockEventReportId];
        return next;
      });
    }
  }, [eventId]);

  // Derive lock state from the top-level `lock` object embedded in each case by the API
  useEffect(() => {
    const isReportLockEnabled = (me?.adminFeatures ?? []).some(
      (f) => f.feature === AdminFeatureEnum.REPORT_LOCK
    );
    if (!isReportLockEnabled) return;

    const snapshot: Record<number, { name: string }> = {};
    caseDetails.forEach((c) => {
      // lock is per-case; find the active draft report to get its ID for the key
      const draftReport = c.reports?.find((r) => !r.status);
      if (draftReport?.id && c.lock?.locked && c.lock?.locked_by) {
        snapshot[draftReport.id] = { name: c.lock.locked_by.display_name };
      }
    });
    setLockedReports(snapshot);
  }, [caseDetails, me]);

  const handleToggleReportForm = () => setShowReportForm((prev) => !prev);

  const handleToggleReportHistory = () => setShowReportHistory((showReportHistory) => !showReportHistory);

  const handleCloseCaseOverview = () => {
    setActiveCase(undefined);
    setShowCaseOverview(false);
  };

  const handleRowContextMenu = (
    record: CaseDetail,
    event: React.MouseEvent
  ) => {
    event.preventDefault();
    setSelectedRow(record);
    setMenuPosition({ x: event.pageX, y: event.pageY });
    setMenuVisible(true);
  };

  const history = useHistory();

  const handleResetFilters = () => {
    history.replace(location.pathname);
  };

  const handleSeriesOpen = (caseId: number, seriesIds: string[]) => {
    // Join raw folder paths with a comma — URLSearchParams.set (inside
    // buildCaseDetailViewerUrl) percent-encodes the value exactly once.
    // Encoding here would cause double-encoding and break the viewer fetch.
    const seriesCsv = seriesIds.length > 0 ? seriesIds.join(",") : undefined;
    window.open(
      buildCaseDetailViewerUrl(caseId, seriesCsv ? { seriesIdCsv: seriesCsv } : undefined),
      "_blank"
    );
  };

  const handleRowChange = (caseDetail: CaseDetail, _: number | undefined) => {
    return {
      onClick: (event: any) => {
        if (event.target.closest(".ant-table-row-expand-icon")) return;
        event.preventDefault();
        if (caseDetail?.id) {
          window.open(buildCaseDetailViewerUrl(caseDetail.id), "_blank");
        }
      },
      onContextMenu: (event: React.MouseEvent) =>
        handleRowContextMenu(caseDetail, event),
    };
  };

  const handleUpdateTags = (caseId: number, tags: Tag[]) => {
    const caseIndex = caseDetails.findIndex(
      (caseItem) => caseItem.id === caseId
    );
    if (caseIndex >= 0) {
      caseDetails[caseIndex].tags = tags;
    }
    setCaseDetails([...caseDetails]);
  };

  const handlePageChange = (pagination: TablePaginationConfig) => {
    const values = Object.assign(new CaseFilterParams(), {
      ...formValues,
      page: pagination.current,
      perPage: pagination.pageSize,
    });
    updateUrlParams(values);
  };

  const handleUploadCaseSuccess = (caseDetail: CaseDetail) => {
    const caseIndex = caseDetails.findIndex(
      (caseItem) => caseItem.id === caseDetail.id
    );
    if (caseIndex >= 0) {
      caseDetails[caseIndex] = caseDetail;
    } else {
      caseDetails.unshift(caseDetail);
    }
    setCaseDetails([...caseDetails]);
  };

  // Initial data fetch with URL parameters
  useEffect(() => {
    const initialFilters = getInitialFiltersFromURL(location.search);
    setFormValues(initialFilters);
    handleFetchCases(initialFilters);
  }, [location.search]); // Re-fetch when URL changes

  useEffect(() => {
    ProfileService.getProfile(
      UserRoleEnum.DOCTOR,
      (doctor: Doctor) => {
        setMe(doctor);
      },
      () => {},
      () => {}
    );
  }, []);

  // Update URL with current filter values
  const updateUrlParams = (values: CaseFilterParams) => {
    const searchParams = new URLSearchParams();

    // Add non-empty filter values to URL
    Object.entries(values).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        searchParams.set(key, String(value));
      }
    });

    // Update URL without page reload
    history.replace(`${location.pathname}?${searchParams.toString()}`);
  };

  const handleFetchCases = (formValues: CaseFilterParams, isSyncing: boolean = false) => {
    if(isSyncing) {
      setSyncing(true);
    } else {
      setLoading(true);
    }
    DoctorCaseService.fetchDoctorCases(
      formValues,
      (caseDetails: CaseDetail[], paginationMeta: PaginationMeta) => {
        setCaseDetails(caseDetails);
        setPaginationMeta(paginationMeta);
        mergeCaseChatUnread(buildCaseChatUnreadCountsFromCases(caseDetails));
      },
      () => {},
      () => {
        if(isSyncing) {
          setSyncing(false);
        } else {
          setLoading(false);
        }
      }
    );
  };

  const handleAssignmentSuccess = (caseDetail: CaseDetail) => {
    const caseIndex = caseDetails.findIndex(
      (caseItem) => caseItem.id === caseDetail.id
    );
    if (caseIndex >= 0) {
      caseDetails[caseIndex] = caseDetail;
    }
    setCaseDetails([...caseDetails]);
    if (assignmentPopoverRef?.current && assignmentPopoverRef.current) {
      assignmentPopoverRef.current.setPopupVisible(false);
    }
  };

  const handleDownloadDetails = (caseDetail: CaseDetail) => {
      setActiveCase(caseDetail);

      if (!caseDetail?.id) return;

      setDownloadZipLoading(true);

      let pollInterval: NodeJS.Timeout | null = null;

      const stopPolling = () => {
          if (pollInterval) {
              clearInterval(pollInterval);
              pollInterval = null;
          }
          setDownloadZipLoading(false);
      };

      const openZipIfAvailable = (response: any) => {
          if (response?.url) {
              window.open(response.url, "_blank");
              stopPolling();
              return true;
          }
          return false;
      };

      // -----------------------------
      // Initial request
      // -----------------------------
      DoctorCaseService.downloadDoctorCase(
          Number(caseDetail.id),
          (response: any) => {
              Notification({
                  message: "Zip file is getting ready for download",
                  type: NotificationTypes.SUCCESS,
              });
              // If URL already exists → open immediately
              if (openZipIfAvailable(response)) return;

              // -----------------------------
              // Start polling every 10 seconds
              // -----------------------------
              pollInterval = setInterval(() => {
                  DoctorCaseService.downloadDoctorZipCase(
                      Number(caseDetail.id),
                      (pollResponse: any) => {
                          openZipIfAvailable(pollResponse);
                          // setDownloadZipLoading(false);
                      },
                      () => {},
                      () => {}
                  );
              }, 10_000);
          },
          () => {},
          () => {}
      );
  };

  const handleCaseAssignment = (checked: boolean, caseDetail: any) => {
    if (checked) {
      DoctorCaseService.removeCaseAssignment(
        caseDetail,
        (caseDetail: CaseDetail) => {
          const caseIndex = caseDetails.findIndex(
            (caseItem) => caseItem.id === caseDetail.id
          );
          if (caseIndex >= 0) {
            const newCaseDetails = [...caseDetails];
            newCaseDetails[caseIndex] = caseDetail;
            setCaseDetails(newCaseDetails);
          }
        },
        () => {},
        () => {}
      );
    } else {
      DoctorCaseService.selfAssignCase(
        caseDetail,
        (caseDetail: CaseDetail) => {
          const caseIndex = caseDetails.findIndex(
            (caseItem) => caseItem.id === caseDetail.id
          );
          if (caseIndex >= 0) {
            caseDetails[caseIndex] = caseDetail;
          }
          setCaseDetails([...caseDetails]);
        },
        () => {},
        () => {}
      );
    }
  };

  const handleCaseReopen = (caseDetail: CaseDetail) => {
    DoctorCaseService.reopenCase(
      caseDetail,
      (caseDetail: CaseDetail) => {
        const caseIndex = caseDetails.findIndex(
          (caseItem) => caseItem.id === caseDetail.id
        );
        if (caseIndex >= 0) {
          const newCaseDetails = [...caseDetails];
          newCaseDetails[caseIndex] = caseDetail;
          setCaseDetails(newCaseDetails);
        }
      },
      () => {},
      () => {}
    );
  };

  const handleDownloadReport = (
    caseDetail: CaseDetail,
    caseType: DownloadFileTypeEnum,
    withLetterHead: boolean,
    reportId?: number
  ) => {
    setActiveCase(caseDetail);
    setDownloadLoading(true);
    if (caseDetail?.id) {
      ReportService.downloadReport(
        caseType,
        caseDetail,
        withLetterHead,
        reportId ?? 0,
        (reportUrl: string) => {
          window.open(reportUrl, "_blank");
        },
        () => {},
        () => {
          setActiveCase(undefined);
          setDownloadLoading(false);
        }
      );
    }
  };

  const handleViewReport = (
      caseDetail: CaseDetail,
      reportId?: number,
  ) => {
    setActiveCase(caseDetail);
    setDownloadLoading(true);
    if (caseDetail?.id) {
      const apiMethod = ReportService.previewReport;
      apiMethod(
          caseDetail?.id,
          reportId ?? 0,
          (data: Blob) => {
            const fileURL = window.URL.createObjectURL(
                new Blob([data], { type: "application/pdf" })
            );
            const pdfWindow = window.open(fileURL, "_blank");
            if (pdfWindow) {
              pdfWindow.onload = () => {
                window.URL.revokeObjectURL(fileURL);
              };
            }
          },
          () => {},
          () => {
            setActiveCase(undefined);
            setDownloadLoading(false);
          }
      );
    }
  };

  const handleDownloadDirectReport = (
    caseDetail: CaseDetail | undefined,
    reportId?: number | undefined,
  ) => {
    if (caseDetail?.id) {
      ReportService.downloadDirectReport(
          caseDetail?.id,
          reportId ?? 0,
          (reportUrl: string) => {
            window.open(reportUrl, "_blank");
          },
          () => {},
          () => {
          }
      );
    }
  };

  const handleCaseShareLink = (caseDetail: CaseDetail) => {
    setActiveCase(caseDetail);
    if (caseDetail?.id) {
      SharedCaseService.getCaseShareLink(
        Number(caseDetail?.id),
        (targetUrl: any) => {
          copyCaseDetailsToClipboard(caseDetail, targetUrl);
        },
        () => {},
        () => {}
      );
    }
  };


  const handleEditCase = (caseDetail: CaseDetail) => () => {
    setActiveCase(caseDetail);
    handleToggleCaseForm();
  };

  useEffect(() => {
    if (createdCaseId) {
      handleFetchCases(formValues, true);
      setNewCaseCreated(null);
      // caseDetails.unshift(newCaseDetail);
      // setCaseDetails([...caseDetails]);
    }
  }, [createdCaseId, setNewCaseCreated]);

  useEffect(() => {
    if (deletedCaseId) {
      handleFetchCases(formValues, true);
      setCaseDeleted(null);
    }
  }, [deletedCaseId, setCaseDeleted]);

  useEffect(() => {
    if (updatedCaseId) {
      // const caseIndex = caseDetails.findIndex(
      //   (caseDetail) => caseDetail.id === updatedCaseDetail.id
      // );
      // if (caseIndex >= 0) {
      //   caseDetails[caseIndex] = updatedCaseDetail;
      //   setCaseDetails([...caseDetails]);
      // }
      handleFetchCases(formValues, true);
      setCaseDetailUpdated(null);
    }
  }, [updatedCaseId, setCaseDetailUpdated]);

  const [columns, setColumns] = useState<any>([]);

  const [listingPrefsApi, setListingPrefsApi] = useState<
    ListingColumnPreferencesResponse | null | undefined
  >(undefined);

  const columnsRef = useRef<any[]>([]);
  const listingPrefsRef = useRef(listingPrefsApi);
  useEffect(() => {
    columnsRef.current = columns;
  }, [columns]);
  useEffect(() => {
    listingPrefsRef.current = listingPrefsApi;
  }, [listingPrefsApi]);

  const handleMouseDown = (e: any, index: any) => {
    resizingColumnRef.current = index;
    startXRef.current = e.clientX;
    startWidthRef.current = columns[index].width;

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  const handleMouseMove = (e: any) => {
    if (resizingColumnRef.current !== null) {
      const idx = resizingColumnRef.current;
      const newWidth = startWidthRef.current + (e.clientX - startXRef.current);
      const newColumns = [...columns];
      const key = newColumns[idx]?.listingColumnKey;
      const minW = minWidthForListingColumnKey(key, ACTIONS_COLUMN_MIN_WIDTH);
      newColumns[idx].width = Math.max(newWidth, minW);
      columnsRef.current = newColumns;
      setColumns(newColumns);
    }
  };

  const handleMouseUp = () => {
    const idx = resizingColumnRef.current;
    resizingColumnRef.current = null;
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
    if (idx === null) return;
    const prefs = listingPrefsRef.current;
    const cols = columnsRef.current;
    if (!prefs?.columns?.length) return;
    const endW = cols[idx]?.width;
    if (endW === undefined) return;
    if (Math.round(Number(startWidthRef.current)) === Math.round(Number(endW))) return;
    const rows = mergeListingWidthsFromTable(cols, prefs.columns);
    ListingColumnPreferenceService.save(
      UserRoleEnum.DOCTOR,
      LISTING_CONTEXT.DOCTOR_CASES,
      rows,
      (res) => {
        setListingPrefsApi((prev) =>
          prev && res.columns ? { ...prev, columns: res.columns } : prev
        );
      },
      () => {},
      () => {}
    );
  };

  useEffect(() => {
    if (!me?.id) return;
    ListingColumnPreferenceService.fetch(
      UserRoleEnum.DOCTOR,
      LISTING_CONTEXT.DOCTOR_CASES,
      (data) => setListingPrefsApi(data),
      () => setListingPrefsApi(null),
      () => {}
    );
  }, [me?.id]);

  useEffect(() => {
    if (!me || listingPrefsApi === undefined) return;

    const screenWidth = window.innerWidth;
    const adminFeatures = me?.adminFeatures?.map(
      (adminFeature) => adminFeature.feature
    );

    const doctorFeatures = me?.doctorFeatures?.map(
      (doctorFeature) => doctorFeature.feature
    ) ?? [];

    const hasAdminPrevileges = doctorFeatures.includes(DoctorFeatureEnum.ADMIN_PRIVILEGES);

    const hasTypistPrevileges = doctorFeatures.includes(DoctorFeatureEnum.TYPIST_LOGIN);

    const hasAssignCasePrevileges = doctorFeatures.includes(DoctorFeatureEnum.ASSIGN_CASE);

    const hasDefaultFullScreen = doctorFeatures.includes(DoctorFeatureEnum.REPORT_EDIT_FULL_SCREEN_DEFAULT);

    const isCosignEnabled = adminFeatures?.includes(AdminFeatureEnum.COSIGN) ?? false;

    const isReportLockEnabled = (me?.adminFeatures ?? []).some(
      (f) => f.feature === AdminFeatureEnum.REPORT_LOCK
    );

    const canForceUnlock = doctorFeatures.includes(DoctorFeatureEnum.FORCE_UNLOCK);

    const canGenerateReport = !doctorFeatures.includes(DoctorFeatureEnum.NO_REPORT_EDIT);

    const defs: Record<string, any> = {};

    defs[ListingColumnKey.TAGS] = {
        listingColumnKey: ListingColumnKey.TAGS,
        title: "Tags",
        dataIndex: "id",
        key: "id",
        width: 75,
        ellipsis: true,
        fixed: screenWidth > 900 ? "left" : undefined,
        render: (_: number, caseDetail: CaseDetail) => (
          <div className="doctor-cases__tags">
            {caseDetail?.tags?.filter((tag) => tag?.name?.toLowerCase() !== TagEnum.CASE_OPENED).map((tag) => {
              const isInteresting = tag?.name?.toLowerCase() === TagEnum.INTERESTING;
              const tooltipTitle = isInteresting && tag?.keyword
                ? `${tag.formattedName}: ${tag.keyword}`
                : tag.formattedName;
              return (
                <Tooltip title={tooltipTitle} key={tag.id}>
                  <span
                    className="doctor-cases__tag-item"
                    style={{ backgroundColor: tag.color }}
                  />
                </Tooltip>
              );
            })}
          </div>
        ),
        onCell: (caseDetail: CaseDetail) => {
          const caseOpenedTag = caseDetail?.tags?.find(
            (tag) => tag?.name?.toLowerCase() === TagEnum.CASE_OPENED
          );
          return caseOpenedTag
            ? { className: "doctor-cases__tag-cell--case-opened", style: { "--case-opened-bg": hexToRgba(caseOpenedTag.color ?? "#000000", 1) } as React.CSSProperties }
            : {};
        },
      };

    defs[ListingColumnKey.PATIENT_ID] = {
        listingColumnKey: ListingColumnKey.PATIENT_ID,
        title: "Patient ID",
        dataIndex: "patientId",
        key: "patientId",
        width: 100,
        fixed: screenWidth > 900 ? "left" : undefined,
        ellipsis: true,
        render: (patientId: string, caseDetail: CaseDetail) => (
          <div
            className="admin-cases__patient-id"
            style={{ display: "flex", alignItems: "center" }}
          >
            {patientId}
          </div>
        ),
        onCell: getCustomCellStyles(100),
      };

    defs[ListingColumnKey.PATIENT_NAME] = {
        listingColumnKey: ListingColumnKey.PATIENT_NAME,
        title: "Patient Name",
        dataIndex: "patientName",
        key: "patientName",
        width: 150,
        fixed: screenWidth > 900 ? "left" : undefined,
        ellipsis: true,
        onCell: getCustomCellStyles(150),
      };

    defs[ListingColumnKey.PATIENT_AGE] = {
        listingColumnKey: ListingColumnKey.PATIENT_AGE,
        title: "Age",
        dataIndex: "age",
        key: "age",
        width: 80,
        ellipsis: true,
        onCell: getCustomCellStyles(80),
      };

    defs[ListingColumnKey.PATIENT_GENDER] = {
        listingColumnKey: ListingColumnKey.PATIENT_GENDER,
        title: "Gender",
        dataIndex: "gender",
        key: "gender",
        width: 90,
        ellipsis: true,
        onCell: getCustomCellStyles(90),
      };

    defs[ListingColumnKey.STUDY] = {
        listingColumnKey: ListingColumnKey.STUDY,
        title: "Study",
        dataIndex: "scanTypeName",
        key: "scanTypeName",
        width: 100,
        ellipsis: true,
        onCell: getCustomCellStyles(100),
        render: (_: string, record: CaseDetail) => (
          <span className="admin-cases__study">{record?.getStudyName()}</span>
        ),
      };

    if (
      adminFeatures &&
      adminFeatures?.includes(AdminFeatureEnum.SHOW_PATIENT_HISTORY)
    ) {
      defs[ListingColumnKey.PATIENT_HISTORY] = {
              listingColumnKey: ListingColumnKey.PATIENT_HISTORY,
              title: "Patient History",
              dataIndex: "parsedPatientHistory",
              key: "parsedPatientHistory",
              width: 150,
              ellipsis: true,
              onCell: getCustomCellStyles(150),
            };
    }

    defs[ListingColumnKey.SCAN_CENTER] = {
        listingColumnKey: ListingColumnKey.SCAN_CENTER,
        title: "Scan Center",
        dataIndex: "scanCenterName",
        key: "scanCenterName",
        width: 100,
        ellipsis: true,
        onCell: getCustomCellStyles(100),
      };

    defs[ListingColumnKey.REFERRING_DOCTOR] = {
        listingColumnKey: ListingColumnKey.REFERRING_DOCTOR,
        title: "Referring Doctor",
        dataIndex: "referringDoctor",
        key: "referringDoctor",
        width: 150,
        ellipsis: true,
        onCell: getCustomCellStyles(150),
      };

    if (
      adminFeatures &&
      adminFeatures?.includes(AdminFeatureEnum.ACQUISITION_DATE)
    ) {
      defs[ListingColumnKey.STUDY_DATE] = {
        listingColumnKey: ListingColumnKey.STUDY_DATE,
        title: "Study Date",
        dataIndex: "studyDate",
        key: "studyDate",
        ellipsis: true,
        width: 150,
        onCell: getCustomCellStyles(150),
        sorter: (a: any, b: any) => {
          const dateA = a.acquisitionDate || "";
          const dateB = b.acquisitionDate || "";
          return dateA.localeCompare(dateB);
        },
        render: (_: string, record: any) => {
          const date = record.acquisitionDate;
          return (
            <span>
              {date ? (
                <span>
                  {moment(date).format("DD-MMM-YY")}{" "}
                  {moment(date).format("hh:mm A")}
                </span>
              ) : (
                "-"
              )}
            </span>
          );
        },
      };
    }

    defs[ListingColumnKey.UPLOADED_DATE] = {
        listingColumnKey: ListingColumnKey.UPLOADED_DATE,
        title: "Uploaded Date",
        dataIndex: "uploadedDate",
        key: "uploadedDate",
        sorter: (a: any, b: any) => {
          const dateA = a.createdAt || "";
          const dateB = b.createdAt || "";
          return dateA.localeCompare(dateB);
        },
        ellipsis: true,
        render: (_: string, record: any) => {
          const date = record.createdAt || "";
          return (
            <span>
              {date ? (
                <span>
                  {moment(date).format("DD-MMM-YY")}{" "}
                  {moment(date).format("hh:mm A")}
                </span>
              ) : (
                "NA"
              )}
            </span>
          );
        },
        width: 150,
        onCell: getCustomCellStyles(150),
      };

    if (hasAdminPrevileges) {
      defs[ListingColumnKey.ASSIGNED_DOCTOR] = {
        listingColumnKey: ListingColumnKey.ASSIGNED_DOCTOR,
        title: "Assigned Doctor",
        dataIndex: "assignedToDoctorName",
        key: "assignedToDoctorName",
        ellipsis: true,
        render: (doctorName: string) => (
          <span className="admin-cases__assigned-doctor">
            {doctorName || "NA"}
          </span>
        ),
        width: 130,
        onCell: getCustomCellStyles(130),
      };
    }

    defs[ListingColumnKey.TIME_ELAPSED] = {
        listingColumnKey: ListingColumnKey.TIME_ELAPSED,
        title: "Time Elapsed",
        dataIndex: "timeElapsed",
        key: "timeElapsed",
        ellipsis: true,
        width: 120,
        onCell: getCustomCellStyles(120),
      };

    defs[ListingColumnKey.TAT] = {
        listingColumnKey: ListingColumnKey.TAT,
        title: "TAT",
        dataIndex: "tat",
        key: "tat",
        ellipsis: true,
        width: 100,
        onCell: getCustomCellStyles(100),
      };

    defs[ListingColumnKey.STATUS] = {
        listingColumnKey: ListingColumnKey.STATUS,
        title: "Status",
        dataIndex: "status",
        key: "status",
        width: 140,
        onCell: () => ({
          className: "doctor-cases__status-td",
          style: {
            maxWidth: 140,
            minWidth: 100,
          },
        }),
        sorter: (a: any, b: any) => a.status.localeCompare(b.status),
        render: (status: string, caseDetail: CaseDetail) => {
          const hasDraftReport =
            status === CaseStatusEnum.ASSIGNED &&
            (caseDetail.reports?.some((r) => r.status === false) ?? false);
          const draftReport = caseDetail.reports?.find((r) => r.status === false);
          const lockInfo = draftReport?.id ? lockedReports[draftReport.id] : undefined;
          return (
            <div
              className="doctor-cases__status-wrapper"
              onClick={stopPropogateEvent}
            >
              <span className={`doctor-cases__status ${status}`}>
                {formatStatus(status)}
              </span>
              {hasDraftReport && (
                <Tooltip title="Report drafted — not yet submitted">
                  <FormOutlined className="doctor-cases__draft-icon" />
                </Tooltip>
              )}
              {hasDraftReport && lockInfo && isReportLockEnabled && (
                canForceUnlock ? (
                  <Popover
                    content={
                      <div>
                        <Button
                          size="small"
                          danger
                          onClick={(e) => {
                            e.stopPropagation();
                            if (!draftReport?.id) return;
                            ReportService.forceReleaseReportLock(
                              draftReport.id,
                              () => {
                                setLockedReports((prev) => {
                                  const next = { ...prev };
                                  delete next[draftReport.id!];
                                  return next;
                                });
                                Notification({ message: "Lock force-released", type: NotificationTypes.SUCCESS });
                              },
                              () => {
                                Notification({ message: "Failed to force-release lock", type: NotificationTypes.ERROR });
                              },
                              () => {}
                            );
                          }}
                        >
                          Force unlock
                        </Button>
                      </div>
                    }
                    title={<span>Locked by <strong>{lockInfo.name}</strong></span>}
                    trigger="hover"
                    overlayStyle={{ maxWidth: 220 }}
                  >
                    <LockOutlined style={{ color: "#f5222d", marginLeft: 4, cursor: "pointer" }} />
                  </Popover>
                ) : (
                  <Tooltip title={`Locked by ${lockInfo.name}`}>
                    <LockOutlined style={{ color: "#f5222d", marginLeft: 4 }} />
                  </Tooltip>
                )
              )}
            </div>
          );
        },
      };

    defs[ListingColumnKey.ACTIONS] = {
        listingColumnKey: ListingColumnKey.ACTIONS,
        title: "Actions",
        dataIndex: "id",
        key: "id",
        width: DEFAULT_ACTIONS_COLUMN_WIDTH,
        render: (_: string, caseDetail: CaseDetail) => {
          const reportedReports = getReportedReports(caseDetail);
          const latestReport = reportedReports.length > 0
          ? reportedReports.reduce((a, b) => {
              const aDate = a?.updatedAt ? new Date(a.updatedAt) : new Date(0);
              const bDate = b?.updatedAt ? new Date(b.updatedAt) : new Date(0);
              return aDate > bDate ? a : b;
            })
          : undefined;
          const isCurrentUserAssigned = caseDetail?.assignedToDoctorId === me?.id;
          const isTypist = doctorFeatures.includes(DoctorFeatureEnum.TYPIST_LOGIN);
          const actionDraftReport = caseDetail.reports?.find((r) => r.status === false);
          const isAssignmentLocked =
            isReportLockEnabled &&
            !!actionDraftReport?.id &&
            !!lockedReports[actionDraftReport.id];
          const chatUnread = getDisplayedCaseChatUnread(
            caseDetail.id,
            caseDetail.unreadChatCount,
            caseChatUnreadCounts,
            caseChat?.id ?? null
          );
          // Generate Report auto-assigns the case to the current doctor via
          // cosign_assign whenever the cosign rule is taking the case from
          // someone else (or assigning a previously-unowned case). The
          // helper returns a state-aware message + null when no popup is
          // needed (case is mine, REPORTED, TO_BE_APPROVED, or I'm a typist).
          const cosignConfirm = getCosignConfirm({
            caseDetail,
            userRole: UserRoleEnum.DOCTOR,
            userId: me?.id,
            isTypist,
            isCosignEnabled,
          });
          const openGenerateReport = () => {
            if (hasDefaultFullScreen) {
              const path = generatePath(AppRoutes.GENERATE_REPORT, {
                caseId: String(caseDetail.id),
              });
              const returnSearch = location.search
                ? `?returnSearch=${encodeURIComponent(location.search.slice(1))}`
                : "";
              window.open(
                window.location.origin + path + returnSearch,
                "_blank"
              );
            } else {
              setActiveCase(caseDetail);
              setShowReportForm(true);
            }
          };
          return (
            <div onClick={stopPropogateEvent} className="case-list__row-actions">
              {
                hasAssignCasePrevileges && (
                  isAssignmentLocked ? (
                    <Tooltip title="Cannot reassign — report is currently locked">
                      <Button icon={<UserAddOutlined />} disabled />
                    </Tooltip>
                  ) : (
                    <Tooltip title="Assign Case">
                      <Popover
                        ref={assignmentPopoverRef}
                        destroyTooltipOnHide
                        overlayClassName="admin-cases__assignment-popover"
                        placement="bottomLeft"
                        content={
                          <div>
                            <CaseAssignmentForm
                              caseDetail={caseDetail}
                              onSuccess={handleAssignmentSuccess}
                            />
                          </div>
                        }
                        title="Assign case"
                        trigger="click"
                      >
                        <Button icon={<UserAddOutlined />} />
                      </Popover>
                    </Tooltip>
                  )
                )
              }
              {
                !hasAssignCasePrevileges && (
                  <>
                    {
                      caseDetail?.status === CaseStatusEnum.UNASSIGNED &&
                      (me?.doctorSelfAssign || hasAdminPrevileges) && (
                        <Tooltip title={isAssignmentLocked ? "Cannot assign — report is currently locked" : "Self Assign Case"}>
                          <Popconfirm
                            title="Are you sure?"
                            disabled={isAssignmentLocked}
                            onConfirm={() =>
                              handleCaseAssignment(
                                false,
                                caseDetail
                              )
                            }
                            okText={"Yes, Assign to me"}
                            cancelText="No"
                            placement="bottom"
                          >
                            <Switch
                              checked={false}
                              onChange={(_checked) => {}}
                              disabled={isAssignmentLocked}
                            />
                          </Popconfirm>
                        </Tooltip>
                      )
                    }
                    {
                      caseDetail?.status === CaseStatusEnum.ASSIGNED &&
                      (me?.doctorSelfAssign || hasAdminPrevileges) && (
                        isCurrentUserAssigned ? (
                          <Tooltip title={isAssignmentLocked ? "Cannot remove assignment — report is currently locked" : "Remove Assignment"}>
                            <Popconfirm
                              title="Are you sure?"
                              disabled={isAssignmentLocked}
                              onConfirm={() =>
                                handleCaseAssignment(
                                  true,
                                  caseDetail
                                )
                              }
                              okText={"Yes, Remove assignment"}
                              cancelText="No"
                              placement="bottom"
                            >
                              <Switch
                                checked={true}
                                onChange={(_checked) => {}}
                                disabled={isAssignmentLocked}
                              />
                            </Popconfirm>
                          </Tooltip>
                        )
                        : (
                          <Tooltip title={isAssignmentLocked ? "Cannot assign — report is currently locked" : "Self Assign Case"}>
                            <Popconfirm
                              title="Are you sure?"
                              disabled={isAssignmentLocked}
                              onConfirm={() =>
                                handleCaseAssignment(
                                  false,
                                  caseDetail
                                )
                              }
                              okText={"Yes, Assign to me"}
                              cancelText="No"
                              placement="bottom"
                            >
                              <Switch
                                checked={false}
                                onChange={(_checked) => {}}
                                disabled={isAssignmentLocked}
                              />
                            </Popconfirm>
                          </Tooltip>
                      ))
                    }
                  </>
                )
              }
              {(caseDetail?.status === CaseStatusEnum.REPORTED ||
                caseDetail?.status === CaseStatusEnum.TO_BE_APPROVED
              ) &&  !isTypist && (
                  <Tooltip title="Reopen Case">
                    <Popconfirm
                      title="Are you sure?"
                      onConfirm={() => handleCaseReopen(caseDetail)}
                      okText={"Yes, Reopen the case"}
                      cancelText="No"
                      placement="bottom"
                    >
                      <Button icon={<RedoOutlined />} />
                    </Popconfirm>
                  </Tooltip>
                )}
              {canGenerateReport && ((isCosignEnabled &&
                  caseDetail?.status !== CaseStatusEnum.REPORTED &&
                  caseDetail?.status !== CaseStatusEnum.TO_BE_APPROVED) ||
                (caseDetail?.status === CaseStatusEnum.ASSIGNED && isCurrentUserAssigned) ||
                (isTypist &&
                  caseDetail?.status === CaseStatusEnum.ASSIGNED)) && (
                cosignConfirm ? (
                  <Popconfirm
                    title={cosignConfirm.message}
                    okText={cosignConfirm.okText}
                    cancelText="Cancel"
                    placement="topRight"
                    onConfirm={openGenerateReport}
                  >
                    <Tooltip title="Generate Report">
                      <Button icon={<FormOutlined />} />
                    </Tooltip>
                  </Popconfirm>
                ) : (
                  <Tooltip title="Generate Report">
                    <Button
                      icon={<FormOutlined />}
                      onClick={openGenerateReport}
                    />
                  </Tooltip>
                )
              )}
              <Tooltip title="Download Case">
                <Button
                  loading={
                    activeCase?.id === caseDetail?.id && downloadZipLoading
                  }
                  icon={<CloudDownloadOutlined />}
                  onClick={() => {
                    handleDownloadDetails(caseDetail);
                  }}
                />
              </Tooltip>
              {caseDetail?.status === CaseStatusEnum.REPORTED && (
                <Tooltip title="Download Latest Report">
                  <Popover
                    destroyTooltipOnHide
                    overlayClassName="admin-cases__assignment-popover"
                    placement="bottomLeft"
                    content={
                      <div>
                        <Menu mode="vertical" className="border-none">
                          {
                            latestReport?.directReportUpload ? (
                              <Menu.Item
                                className="navbar-item m-0"
                                key="download_direct"
                                onClick={() => {
                                  handleDownloadDirectReport(
                                      caseDetail,
                                      latestReport?.id
                                  );
                                }}>
                                Download Report
                              </Menu.Item>
                            ):(
                              <>
                                <Menu.Item
                                  className="navbar-item m-0"
                                  key="view"
                                  onClick={() => {
                                    handleViewReport(
                                        caseDetail,
                                        latestReport?.id
                                    );
                                  }}
                                >
                                  View Report
                                </Menu.Item>
                                <Menu.Item
                                  className="navbar-item m-1"
                                  key="with_letterhead"
                                  onClick={() => {
                                    handleDownloadReport(
                                      caseDetail,
                                      DownloadFileTypeEnum.PDF,
                                      true,
                                      latestReport?.id
                                    );
                                  }}
                                >
                                  Download with Letterhead
                                </Menu.Item>
                                <Menu.Item
                                  className="navbar-item m-2"
                                  key="without_letterhead"
                                  onClick={() => {
                                    handleDownloadReport(
                                      caseDetail,
                                      DownloadFileTypeEnum.PDF,
                                      false,
                                      latestReport?.id
                                    );
                                  }}
                                >
                                  Download without Letterhead
                                </Menu.Item>
                                <Menu.Item
                                  className="navbar-item m-3"
                                  key="as_word"
                                  onClick={() => {
                                    handleDownloadReport(
                                      caseDetail,
                                      DownloadFileTypeEnum.WORD,
                                      false,
                                      latestReport?.id
                                    );
                                  }}
                                >
                                  Download as Word
                                </Menu.Item>
                              </>
                            )
                          }
                        </Menu>
                      </div>
                    }
                    title="Download Latest Report"
                    trigger="click"
                  >
                    <Button
                      loading={
                        activeCase?.id === caseDetail?.id && downloadLoading
                      }
                      icon={<DownloadOutlined />}
                    />
                  </Popover>
                </Tooltip>
              )}
              {adminFeatures?.includes(AdminFeatureEnum.DIGITAL_SHARING) && (
                <Tooltip title="Copy Share Link">
                  <Button
                    icon={<CopyOutlined />}
                    className="clickable-icon"
                    onClick={() => {
                      Notification({
                        message: "Copied",
                        type: NotificationTypes.SUCCESS,
                      });
                      handleCaseShareLink(caseDetail);
                    }}
                  />
                </Tooltip>
              )}
              {reportedReports.length > 0 && (
                  <Tooltip title="Report History">
                    <Button
                        icon={<HistoryOutlined />}
                        onClick={() => {
                          setActiveCase(caseDetail);
                          setShowReportHistory(true);
                        }}
                    />
                  </Tooltip>
              )}
              {caseDetail?.status !== CaseStatusEnum.REPORTED && hasTypistPrevileges && (
                <Tooltip title="Edit Case">
                  <Button
                    icon={<EditOutlined />}
                    onClick={handleEditCase(caseDetail)}
                  />
                </Tooltip>
              )}
              <Tooltip title="Case chat">
                <Badge
                  count={chatUnread}
                  size="small"
                  offset={[-2, 2]}
                  overflowCount={99}
                >
                  <Button
                    icon={<CommentOutlined />}
                    onClick={() => {
                      setCaseChatDrawerCaseId(caseDetail.id!);
                      setCaseChat({
                        id: caseDetail.id!,
                        title:
                          caseDetail.patientName ||
                          caseDetail.patientId ||
                          `Case #${caseDetail.id}`,
                      });
                    }}
                  />
                </Badge>
              </Tooltip>
              <Tooltip title="More Case Details">
                <Button
                  icon={<EllipsisOutlined />}
                  onClick={(event: any) => {
                    setActiveCase(caseDetail);
                    setShowCaseOverview(true);
                  }}
                />
              </Tooltip>
            </div>
          );
        },
        onCell: () => ({ className: "doctor-cases__actions-cell" }),
      };

    const fallbackOrder =
      listingPrefsApi?.eligible_column_keys?.filter((k) => defs[k])?.length
        ? listingPrefsApi!.eligible_column_keys.filter((k) => defs[k])
        : Object.keys(defs);

    setColumns(
      applyListingColumnPreferences(defs, listingPrefsApi?.columns ?? null, fallbackOrder)
    );
  }, [
    me,
    caseDetails,
    caseChat,
    caseChatUnreadCounts,
    downloadLoading,
    downloadZipLoading,
    lockedReports,
    listingPrefsApi,
    activeCase,
  ]);

  const updatedColumns = columns.map((col: any, index: any) => ({
    ...col,
    title: (
      <div className="resizable-header">
        {col.title}
        <div
          className="resizer"
          onMouseDown={(e) => handleMouseDown(e, index)}
        />
      </div>
    ),
  }));

  return (
    <div className="doctor-cases">
      <AppCard>
        <Row>
          <Col span={12}>
            <h2 className="mt-2">Cases</h2>
          </Col>
        </Row>
        <CaseFilterForm
          isDoctor
          formValues={formValues}
          onSubmit={handleSubmit}
          onReset={handleResetFilters}
          onChange={handleOnChange}
          onSync={handleFetchCases}
          loading={isSyncing}
          onListingColumnsSaved={() => {
            ListingColumnPreferenceService.fetch(
              UserRoleEnum.DOCTOR,
              LISTING_CONTEXT.DOCTOR_CASES,
              (data) => setListingPrefsApi(data),
              () => setListingPrefsApi(null),
              () => {}
            );
          }}
        />
        {
          loading ? <AppLoader loading={loading} /> :
          (
            <Table
              dataSource={caseDetails}
              rowKey={(record) => record.id ?? 0}
              scroll={{ x: "max-content", y: `calc(100vh - 375px)` }}
              rowClassName={caseListRowClassName}
              onRow={handleRowChange}
              columns={updatedColumns}
              expandable={{
                expandedRowRender: (record) => (
                  <CaseSeriesExpandRow
                    caseDetailId={record.id!}
                    fetchThumbnails={DoctorCaseService.showDoctorCaseDirectories}
                    fetchDicomFiles={DoctorCaseService.showDoctorCaseDirectoryFiles}
                    onSeriesOpen={handleSeriesOpen}
                  />
                ),
                rowExpandable: (record) => record.id != null,
              }}
              pagination={{
                current: paginationMeta?.currentPage,
                pageSize: paginationMeta?.perPage,
                total: paginationMeta?.totalCount,
                showSizeChanger: true,
                pageSizeOptions: ["10", "15", "20", "50"],
              }}
              onChange={handlePageChange}
            />
          )
        }
        {caseDetails.length > 0 && <TagLegend />}
        <Modal
          destroyOnClose
          visible={showCaseOverview}
          className="primary-modal"
          onCancel={handleCloseCaseOverview}
          footer={null}
          maskClosable={false}
        >
          {activeCase?.id && (
            <CaseOverview
              activeCaseId={activeCase?.id}
              onCancel={handleCloseCaseOverview}
            />
          )}
        </Modal>

        <Modal
          destroyOnClose
          visible={showCaseForm}
          className="primary-modal"
          onCancel={handleToggleCaseForm}
          footer={null}
          maskClosable={false}
        >
          {activeCase && (
            <CaseForm
              caseDetailId={activeCase?.id}
              onSuccess={handleUploadCaseSuccess}
              onClose={() => setShowCaseForm(false)}
            />
          )}
        </Modal>

        <Modal
          destroyOnClose
          visible={showReportHistory}
          onCancel={handleToggleReportHistory}
          footer={null}
          maskClosable={false}
          className="primary-modal"
        >
          <ReportHistory caseDetail={activeCase} />
        </Modal>
      </AppCard>

      <ContextMenu
        visible={menuVisible}
        position={menuPosition}
        selectedRow={selectedRow}
        onClose={() => setMenuVisible(false)}
        onUpdate={handleUpdateTags}
      />
      <CaseChatDrawer
        open={caseChat !== null}
        onClose={() => {
          setCaseChatDrawerCaseId(null);
          setCaseChat(null);
        }}
        caseDetailId={caseChat?.id ?? null}
        title={caseChat?.title}
        userRole={UserRoleEnum.DOCTOR}
        currentUserId={me?.id}
      />
      <Drawer
        destroyOnClose
        title={null}
        className="doctor-cases__generate-report-drawer"
        width="80%"
        onClose={handleToggleReportForm}
        visible={showReportForm}
        maskClosable={false}
        footer={null}
        keyboard={false}
      >
        {activeCase?.id && (
          <ReportForm
            onClose={handleToggleReportForm}
            caseDetailId={activeCase.id}
            onPublish={() => handleFetchCases(formValues)}
          />
        )}
      </Drawer>
    </div>
  );
}

export default CaseContainer(ReportLockContainer(DoctorCases));
